import { render } from "./Demo.vue?vue&type=template&id=5fc34208"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TOP\\Desktop\\vue\\nomad-poc-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__